import { increaseShiftQueueNumber, store } from "@redux"
import convertOrderCombosToCartCombos from "./convertOrderCombosToCartCombos"
import getOrdersTaxItems from "./getOrdersTaxItems"
import calculateTotalTaxes from "./calculateTotalTaxes"
import calculateItemSalePrice from "./calculateItemSalePrice"

const getQueueNumber = (orderId) => {
  const {
    shiftCashier,
    userAccountInfo: { _id: cashierAccountId }
  } = store.getState()

  const queueNumber =
    shiftCashier[cashierAccountId].queueNumbers[orderId]

  if (!!queueNumber) return queueNumber

  const previousQueueNumber =
    Object.keys(shiftCashier[cashierAccountId].queueNumbers).length

  const newQueueNumber =
    previousQueueNumber + 1

  store.dispatch(
    increaseShiftQueueNumber(orderId)
  )

  return newQueueNumber
}

const getOrderPrintData = (order) => {
  const taxesAndCharges = getOrdersTaxItems(order)

  const totalTaxes = calculateTotalTaxes(order)

  const getItemTotalSpecificationItems = (item) => {
    let result = 0

    item.orderItemSpecifications.forEach(orderItemSpecification =>
      orderItemSpecification.specificationItems.forEach(specificationItem => {
        result +=
          item.quantity *
          specificationItem.salePrice *
          (specificationItem.quantity - specificationItem.freeQuantity)
      })
    )

    return result
  }

  const totalSystemDiscounts =
    order.items.reduce((t, item) =>
      t += (item.systemDiscount > 0 ? item.systemDiscount : 0)
      , 0
    )

  const subtotal =
    order.items.reduce((t, item) =>
      t +=
      getItemTotalSpecificationItems(item) +
      calculateItemSalePrice(item) * item.quantity
      , 0
    )

  const totalDiscount =
    totalSystemDiscounts +
    order.deliveryDiscount +
    order.foodDiscount

  const total =
    subtotal +
    totalTaxes +
    order.deliveryFee -
    totalDiscount

  const combos =
    convertOrderCombosToCartCombos(order.items)

  const comboItems = []

  combos.forEach(combo =>
    combo.items.forEach(comboItem =>
      comboItems.push(comboItem)
    )
  )

  const notComboItems =
    order.items.filter(item => !item.comboSet)

  const queueNumber =
    order.dailyOrderNumber !== undefined
      ? String(order.dailyOrderNumber).padStart(3, "0")
      : getQueueNumber(order._id)

  const {
    domain,
    subdomain,
    kitchenTitle,
    serviceTypeName,
    customDomainName
  } = store.getState().systemSettings

  const orderBranch =
    store.getState().userAccountInfo.cashierBranches
      .find(cb => cb._id === order.branchId)

  const items =
    [...notComboItems, ...comboItems].map(item => {
      const specificationItems = []

      const portionLabels = {
        firstHalf: { name: "نیمه اول: ", nameEn: "First half: ", nameAr: "النصف الأول: " },
        secondHalf: { name: "نیمه دوم: ", nameEn: "Second half: ", nameAr: "النصف الثاني: " }
      }

      item.orderItemSpecifications.forEach(orderItemSpecification =>
        orderItemSpecification.specificationItems.forEach(specificationItem => {
          const label = portionLabels[specificationItem.portion]

          specificationItems.push(label
            ? {
                ...specificationItem,
                name: `${label.name}${specificationItem.name}`,
                nameEn: `${label.nameEn}${specificationItem.nameEn}`,
                nameAr: `${label.nameAr}${specificationItem.nameAr}`
              }
            : specificationItem
          )
        })
      )

      return {
        unit: item.unit,
        foodImageCover: item.foodImageCover,
        foodName: item.foodName,
        foodNameEn: item.foodNameEn,
        foodNameAr: item.foodNameAr,
        isSimple: item.isSimple,
        quantity: item.quantity,
        salePrice: item.salePrice,
        optionName: item.option.name,
        optionNameEn: item.option.nameEn,
        optionNameAr: item.option.nameAr,
        foodCode: item.foodCode,
        sku: item.sku,
        barcode: item.option.barcode,
        categoryIds: item.categoryIds,
        systemDiscount: item.systemDiscount,
        specificationItems
      }
    })

  return {
    _id: order._id,
    code: order.code,
    dailyOrderNumber: order.dailyOrderNumber,
    date: order.date,
    items,
    branch: orderBranch || null,
    note: order.note,
    isCod: order.isCod,
    total,
    subtotal,
    subdomain,
    domain,
    customDomainName,
    kitchenTitle,
    serviceTypeName,
    queueNumber,
    taxesAndCharges,
    totalDiscount,
    totalBeforeDiscount: 0,
    totalSystemDiscounts,
    paymentType: order.paymentType || "cash",
    orderStatus: order.orderStatus,
    totalFoodDiscounts: order.foodDiscount,
    totalDeliveryDiscountByCoupon: order.deliveryDiscount,
    tableNumber: order.tableNumber,
    deliveryFee: order.deliveryFee,
    deliveryType: order.deliveryType,
    address: order.address,
    accountId: order.accountId,
    customerFullName: order.customerFullName,
    customerMobilePhone: order.customerMobilePhone,
    customerReferralCode: order.customerReferralCode,
    customerAccountNote: order.customerAccountNote,
    paymentNote: order.paymentNote,
    accountRole: order.accountRole,
    addedBySystem: order.addedBySystem,
    addedByFullName: order.addedByFullName,
    branchName: order.branchName,
    branchContactNumber: order.branchContactNumber,
    branchAddress: order.branchAddress,
    cinemaSolonNumber: order.cinemaSolonNumber
  }
}

export default getOrderPrintData
